import { Component, Inject, OnDestroy, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { ReplaySubject, Subscription } from "rxjs";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AppService } from "@irb/app.service";
import { SecurityMasterService } from "@irb/irb-models/security-master/security-master.service";
import { DataTransferService } from "@irb-common/services/data-transfer.service";
import { IApplyFilterOnLanding } from "@irb/app.model";
import { HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { SelectMultiplePortfoliosGridService } from "./select-multiple-portfolios-grid.service";
import { IPortfolioExportRequest, IPortfolioFilterDDList, IPortfolioModel, IPortMissingAccountAndModel, Portfolio, PortfolioCount } from "@irb/irb-clients/irb-clients.model";
import { PortfolioService } from "@irb/irb-clients/portfolios/portfolio.service";
import { IrbAppEvents, IrbEditorsEvents, IEventSubscriber, IEvent } from "@irb/irb-common/events";
import {IrbSettingsService} from "@irb/irb-settings/irb-settings.service";
import { PortfolioLabelsService } from "@irb/irb-clients/portfolios/portfolios.labels.service";

@Component({ standalone: false,
  selector: "irb-select-multiple-portfolios-dialog",
  templateUrl: "./select-multiple-portfolios-dialog.component.html",
  styleUrls: ["./select-multiple-portfolios-dialog.component.scss"],
})
export class SelectMultiplePortfoliosDialogComponent implements OnDestroy, OnInit, IEventSubscriber {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  selectedOrDeSelectedRecords: any[] = [];
  deselectedFromSelectAllRecords: any[] = [];
  securitySymbolList: any = [];
  customCategoryList: any = [];
  securityModelList: any = [];
  footerContent: any;
  securitiesCount: any;
  securityTypeList: any;
  securityModels: any;
  securityModelId: number = 0;
  isSelectedAll: boolean = false;
  params: any;
  gridOptions: any;
  totalRecordsFromServer: number = 0;
  private applyFilterOnLanding: IApplyFilterOnLanding;
  private securityMaster: any = [];
  dialogTitle: string;
  disableAddBtn: boolean = true;
  // portfolio fields start

  defaultColDef: any;
  columnDefs: any;
  rowSelection: any;
  rowModelType: any;
  portfolioCount: PortfolioCount;
  currentPortfoliosDisplayed: any;
  _portfolios: any[];
  portfolioContentRange: any;
  portfolioModelList: IPortfolioFilterDDList;
  modelNames: string[] = [];
  portfolioCustCatList: IPortfolioFilterDDList;
  portfolioRestrictionList: IPortfolioFilterDDList;
  portfolioCreatedUserList: string[] = [];
  portfolioEditedUserList: string[] = [];
  custcatNames: string[] = [];
  statusValues: string[] = [];
  sideBar: any;
  disableActionBtn = true;
  selectedTaxability: string[] = [];
  selectedPriorityNote: string;
  pendingResults: string;
  taxlossResults: string;
  frameworkComponents: any;
  filterMissingModel: any;
  filterMissingAccount: any;
  icons: any;
  loadingOverlayComponentParams: any;
  overlayType: any;
  uniqueField = "portfolioId";
  eventSubscription: Subscription;
  successfulImportCount: number;
  displaySuccessfulImport: boolean;
  acountsinit: boolean;
  restrictionsInit: boolean;
  _isSelectedAll: boolean;
  _deselectedFromSelectAllRecords: any[] = [];
  selectedAccountValues: string[] = [];
  customCategory: string;
  missingCountDetails: IPortMissingAccountAndModel;
  headerCheckBoxState: string;
  checkSelected: boolean = true;
  isUiTest = false;
  customCategotyColumnHeader = 'Custom Category';
  @ViewChild('noOptionsTemplate') noOptionsTemplate: TemplateRef<any>;
  selectedRowsMap: Map<string, any> = new Map<string, any>();

  constructor(
    public dialogRef: MatDialogRef<any>, 
    public as: AppService, 
    private readonly securityMasterService: SecurityMasterService,
    public dataTransferService: DataTransferService, 
    private gls: SelectMultiplePortfoliosGridService,
    private readonly pfs: PortfolioService, 
    @Inject(MAT_DIALOG_DATA) public eventData: any,
    private iss: IrbSettingsService,
    private pls: PortfolioLabelsService) {
      this.eventSubscription = this.as.getEvents().subscribe((s) => this.processEvent(s));
  }

  ngOnInit(): void {
    this.applyFilterOnLanding = this.as.getWindowsState();
    this.getCustCatLabelfromSettings();
    this.gridOptions = {
      rowModelType: "serverSide",
      columnDefs: this.gls.getColumnDefs(this),
      context: { componentParent: this, parentId: "add-multiple-securities-dialog-grid" }, 
      rowSelection: "multiple",
      onSortChanged: () => {
        this.setDatasource();
      }
    };
    this.frameworkComponents = this.gls.getFrameworkComponents();
    this.getPortfolioCount();
  }

  processEvent(event: IEvent): void {
    switch(event.type) {
      case IrbAppEvents.GRID_FILTER_RESET:
        this.clearAllFilters();
        break;
    }
  }

  getCustCatLabelfromSettings() {
      this.customCategotyColumnHeader = 'Custom Category';
      this.iss.getGlobalSettings().subscribe((globalSettings: any) => {
      this.customCategotyColumnHeader = globalSettings.portfolioCustLabelAbbr;
      this.params.api.getColumnDef("labels").headerName = this.customCategotyColumnHeader;
        this.params.api.refreshHeader();
      });
    }

  onGridReady(params: any) {
    this.params = params;

    if (!this.applyFilterOnLanding?.isUpdatRequired) {
        this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
    }
    
    this.pls.getPortfolioLabels(this);
    this.getPortfolioModel();
    this.getPortfolioCustCat();
  }

  enableDisableBtns() {
    this.disableAddBtn = (this.isSelectedAll || this.selectedRowsMap?.size) ? false : true;
  }
  
  getPortfolioModel() {
    this.pfs.getPortfolioModel().subscribe(
      (res: IPortfolioFilterDDList) => {
        this.portfolioModelList = res;
        for (const record of this.portfolioModelList.items) {
          if (record.name) {
            if (record.name !== "(none)") {
              this.modelNames.push(record.name);
            }
          }
        }
        this.modelNames = this.sortArrayList(this.modelNames);
        const recordStatic: IPortfolioModel = { id: "NoModel", name: "(none)" };
        this.portfolioModelList.items.push(recordStatic);
        this.modelNames.unshift("(none)");
      },
      (err: HttpErrorResponse) => {
        this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
        // console.error(err);
        let m = 'Select multiple Portfolio dialog getPortfolioModel failed.';
        if (err.message) {
          m += ' ' + err.message;
        }
        if (!this.isUiTest)
          throw new Error(m);
      }
    );
  }

  getPortfolioCustCat() {
    this.pfs.getPortfolioCustCat().subscribe(
      (res: IPortfolioFilterDDList) => {
        this.portfolioCustCatList = res;
        for (const record of this.portfolioCustCatList.items) {
          if (record.name) {
            if (record.name !== "(none)") {
              this.custcatNames.push(record.name);
            }
          }
        }
        this.custcatNames = this.sortArrayList(this.custcatNames);
        const recordStatic: IPortfolioModel = { id: "uncategorized", name: "(none)" };
        this.portfolioCustCatList.items.push(recordStatic);
        this.custcatNames.unshift("(none)");
      },
      (err: HttpErrorResponse) => {
        // console.error(err);
        let m = 'Select multiple Portfolio dialog getPortfolioCustCat failed.';
        if (err.message) {
          m += ' ' + err.message;
        }
        if (!this.isUiTest)
          throw new Error(m);
      }
    );
  }

  sortArrayList(arrayList: string[]) {
    return arrayList.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
  }

  addMultiplePortfolios() {
    const selectedPortfolios: any = [];

    if (this.isSelectedAll) {
      const request = {} as IPortfolioExportRequest;
      request.isSelectAll = this.isSelectedAll;
      request.deselectedIds = [];

      this.deselectedFromSelectAllRecords.forEach((node: any) => {
        request.deselectedIds.push(node.portfolioId);
      });

      request.selectedIds = [];
      this.as.fireEvent(IrbAppEvents.SHOW_WAIT);

      this.pfs.getMultiplePortfoliosByFilter(request).subscribe((response: any) => {
        if (response && response.length > 0) {
          const records = response.filter((responsePortfolio: any) => {
            return !this.eventData.data.some((exeitingPortfolio: any) => {
              return responsePortfolio.portfolioId === exeitingPortfolio.portfolioId;
            });
          });

          records.forEach((portItem: any) => {
            portItem.isNew = true;
          });

          this.pfs.clearCriteria();
          this.as.fireEvent(IrbEditorsEvents.SAVE_MULTIPLE_PORTFOLIOS, {
            selectedPortfolios: records
          });

          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        }
      });
      
      this.closeDialog();
    } else {
      this.selectedRowsMap.forEach((portItem: any) => {
        if (!this.isDisabled(portItem)) {
          const item = {
            portfolioId: portItem.portfolioId,
            portfolioName: portItem.portfolioName,
            status: portItem.status,
            isUIdeleted: false,
            isNew: true,
            isImported: false,
            isSmartFiltered: false,
            aggAmount: portItem.aggAmount,
            htlAmount: portItem.htlAmount,
            lossPrty: portItem.lossPrty,
            acctQty: portItem.acctQty,
            pfExtraCash: portItem.pfExtraCash,
          };
          selectedPortfolios.push(item);
        }
      });

      if (selectedPortfolios.length >= 1) {
        const params = {
          selectedPortfolios: selectedPortfolios,
        };
        this.as.fireEvent(IrbEditorsEvents.SAVE_MULTIPLE_PORTFOLIOS, params);
        this.closeDialog();
      }
    }
  }

  clearAllFilters() {
    this.securityMasterService.filterCriteria = "";
    this.dataTransferService.SecurityModelId = 0;
    this.securityModelId = 0;
    this.params.api.setFilterModel(null);
    this.securityMasterService.clearCriteria();
    this.enableDisableBtns(); 
  }

  setDatasource() {
    return {
      getRows: (params: any) => {
        const selectedModelIds = this.getSetFilterSelectedGetIds(params, this.portfolioModelList?.items, "securityModelName");
        const selectedCustCatIds = this.getPortfolioSetFilterSelectedGetIds(params, "labels");
        const selectedRestrictionIds = this.getSetFilterSelectedGetIds(params, this.portfolioRestrictionList?.items, 'psrQty');
        this.pfs.getPortfolios(params, selectedModelIds, selectedCustCatIds, selectedRestrictionIds).subscribe((data) => {
         this.portfolios=<Portfolio[]>data.body;
         this.getCurrentPortfolioCount(data.headers);

          if (this.currentPortfoliosDisplayed === 0) {
            this.params.api.showNoRowsOverlay();
          } else {
            this.params.api.hideOverlay();
          }

          params.success({ rowData: this.portfolios });
          
          if (!Array.isArray(this.portfolios)) {
            const ex: any = (this.portfolios as any).responseUtilityMap;
            if (ex) {
              if (ex['Controller Exception']) {
                const err: any = {};
                err.message = 'Select multiple Portfolio dialog getPortfolios failed. ';
                err.message += ex['Controller Exception'];

                this.params.api.showNoRowsOverlay();
                if (!this.isUiTest)
                  throw new Error(err.message);
              }
            }
          }
        });
      },
    };
  }

  getPortfolioSetFilterSelectedGetIds(params: any, fieldName: string) {
    const selectedValues = params.request.filterModel[fieldName]?.values || [];
    return selectedValues;
  }

  getSetFilterSelectedGetIds(params: any, list: any, fieldName: string) {
    const selectedValues = params.request.filterModel[fieldName]?.values || [];
    list = list?.filter((x: any) => selectedValues.includes(x.name));
    const r = list?.map((x: any) => x.id) || [];
    return r;
  }

  private getCurrentPortfolioCount(headers: HttpHeaders) {
    this.portfolioContentRange = headers.get("Filter-Count");
    const lengthOfContentRange = this.portfolioContentRange ? this.portfolioContentRange.trim().length : 0;
    const indexOfSlash = this.portfolioContentRange ? this.portfolioContentRange.toString().indexOf("/") : 0;
    this.currentPortfoliosDisplayed = this.portfolioContentRange ? parseInt(this.portfolioContentRange.toString().substring(indexOfSlash + 1, lengthOfContentRange)) : 0;
    this.footerContent = this.currentPortfoliosDisplayed + (this.portfolioCount ? " of " + this.portfolioCount.pfCount : "") + " portfolios displayed";
    this.totalRecordsFromServer = Number(this.currentPortfoliosDisplayed);
  }

  getPortfolioCount(): void {
    this.pfs.getPortfolioCount().subscribe((portfolioCount: any) => {
      this.portfolioCount = portfolioCount;
      if (this.currentPortfoliosDisplayed) {
        this.footerContent = this.currentPortfoliosDisplayed + " of " + this.portfolioCount.pfCount + " portfolios displayed";
      }
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.destroyed$.complete();
  }

  get portfolios() {
    return this._portfolios;
  }
  set portfolios(portfolios: any) {
    this._portfolios = portfolios;
  }

  isDisabled(data: any) {
    if(this.eventData.data) {
      return this.eventData.data.some((selectedPortfolio: any) => {
            return selectedPortfolio.portfolioId === data.portfolioId
        });
    }
      return data.authStatus === "Unauthorized";
  }

  getSmartFilteredPortfolios(data: any) {
    if (this.eventData && this.eventData.data) {
      let selectedPortfolio = this.eventData.data.filter((selectedPortfolio: any) => {
        return selectedPortfolio.portfolioId === data.portfolioId;
      });
      // console.log(selectedPortfolio);
      return selectedPortfolio[0] ? selectedPortfolio[0].isSmartFiltered : false;
    } else {
      return false;
    }
  }
}
